import { ORANGE_COLORS } from '@junglescout/styles-library'

export const COLORS = ORANGE_COLORS
